import { render, staticRenderFns } from "./KennelRegistrationList.vue?vue&type=template&id=3655aa5f"
import script from "./KennelRegistrationList.vue?vue&type=script&lang=ts"
export * from "./KennelRegistrationList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports